import { useGetAccountsQuery } from '../../redux/api/fymAPI';
import { useAccountId, useUserToken } from '../../redux/slices/appInfo/hooks';
import { isReadOnlyAccount } from './readOnlyAccounts';

/**
 * True while the active artist is above the artist limit of the plan (`readOnly` in GET
 * /accounts). A write that gets through answers 403 `M24_LIMIT_ARTIST_READ_ONLY`, and
 * `dispatchM24LimitPrompt` opens the artists offer.
 */
export function useIsReadOnlyAccount(): boolean {
  const userToken = useUserToken();
  const activeAccountId = useAccountId();
  const { isReadOnly } = useGetAccountsQuery(undefined, {
    skip: !userToken,
    selectFromResult: ({ data }) => ({
      isReadOnly: isReadOnlyAccount(data?.accounts.find((account) => account.id === activeAccountId)),
    }),
  });
  return isReadOnly;
}
